// Centered single-message row — shared by the loading spinner, load-error, and empty states.
export const CENTER_MESSAGE_SX = {
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  m: 2,
};

export const ADD_ROW_BUTTON_SX = {
  width: 160,
  height: 40,
  borderRadius: '16px',
};
